import * as actionTypes from "../actions/actionTypes";

export const setHandHistoryFilter = data => {
    return {
        type: actionTypes.SET_HAND_HISTORY_FILTER,
        data
    };
};
export const setSelectedHandList = data => {
    return {
        type: actionTypes.SET_SELECTED_HAND_LIST,
        data
    };
};

export const setHandHistoryPrevFilter = data => {
    return {
        type: actionTypes.SET_HAND_HISTORY_PREV_FILTER,
        data
    };
};


/** WEBPACK FOOTER **
 ** ./src/store/actions/handHistoryAction.js
 **/